var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.6 124.5",
    style: {
      enableBackground: "new 0 0 71.6 124.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1896C2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.7,68.6V17c0-8.3-6-15.8-14.3-16.8C22.5-1.1,14,6.6,14,16.3v52.3c-14.1,9-18.3,27.8-9.2,41.9 c5.6,8.7,15.2,14,25.5,14l0.2,0c16.7,0,30.3-13.6,30.3-30.4C60.7,83.8,55.4,74.2,46.7,68.6z M52.7,107c-8,13.9-27,17.4-39.6,6.1 c-5.1-4.6-8.2-11.2-8.4-18.1c-0.2-9.9,5-18.5,12.9-23.1c0.7-0.4,1.2-1.2,1.2-2V16.8c0-5.6,3.8-10.8,9.3-11.9 c7.5-1.5,14.1,4.2,14.1,11.4v53.6c0,0.8,0.4,1.6,1.2,2C55.6,79,59.8,94.7,52.7,107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,77.5V42.3c0-1.3-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3v35.2c-8.8,1.3-14.9,9.4-13.6,18.1 c1.1,7.9,7.9,13.8,15.9,13.8c8.9,0,16.1-7.1,16.1-16C46.5,85.4,40.7,78.6,32.8,77.5z M41.6,95.8c-0.9,4.3-4.4,7.8-8.6,8.7 c-7.4,1.6-13.9-4-13.9-11.1c0-6.3,5.1-11.4,11.4-11.4C37.5,81.9,43.1,88.4,41.6,95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.3,16H54.8c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3h14.5c1.3,0,2.3-1,2.3-2.3C71.6,17,70.6,16,69.3,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.2,32.2c1.3,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3h-8.5c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3H66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.3,39.2H54.8c-1.3,0-2.3,1-2.3,2.3c0,1.3,1,2.3,2.3,2.3h14.5c1.3,0,2.3-1,2.3-2.3 C71.6,40.2,70.6,39.2,69.3,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.2,55.4c1.3,0,2.3-1,2.3-2.3c0-1.3-1-2.3-2.3-2.3h-8.5c-1.3,0-2.3,1-2.3,2.3c0,1.3,1,2.3,2.3,2.3H66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.3,62.4H54.8c-1.3,0-2.3,1-2.3,2.3c0,1.3,1,2.3,2.3,2.3h14.5c1.3,0,2.3-1,2.3-2.3 C71.6,63.4,70.6,62.4,69.3,62.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/Temperature.9e7c2ccb6a8aa6fa92683b1c2e65517e.svg";
export { ForwardRef as ReactComponent };